import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';

/**
 * Standalone Login Callback Page
 * 
 * Handles the OIDC redirect callback for Standalone mode.
 * After successful authentication, redirects user to the main app.
 */
export default function StandaloneLoginCallback() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Wait for auth to complete processing the callback
    if (!auth.isLoading) {
      if (auth.isAuthenticated) {
        navigate('/', { replace: true });
      } else if (auth.error) {
        console.error('[StandaloneLoginCallback] Authentication error:', auth.error);
        // Could redirect to an error page or show error message
        navigate('/', { replace: true });
      }
    }
  }, [auth.isLoading, auth.isAuthenticated, auth.error, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="text-center space-y-4">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
        <p className="text-muted-foreground">Completing sign in...</p>
      </div>
    </div>
  );
}
